"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const pathProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("StockBox", React.createElement(React.Fragment, null,
    React.createElement("path", Object.assign({ d: "M12.9 2.1l8.2 3.7c.4.2.7.5.9.8.2.3.3.6.3 1v8.9c0 .3-.1.7-.3 1-.2.3-.5.5-.8.7L13 21.9c-.3.1-.6.2-.9.2-.3 0-.6-.1-.9-.2L3 18.2c-.5-.2-.8-.5-1-.8-.2-.3-.3-.6-.3-1V7.5c0-.3.1-.7.3-1 .2-.2.5-.5.9-.6l8.2-3.7c.3-.2.6-.3.9-.3.3 0 .6.1.9.2z" }, pathProps)),
    React.createElement("path", Object.assign({ d: "M2 6.5L12 11l10-4.5M12 22V11M6.9 4.1l10.3 4.7" }, pathProps))));
//# sourceMappingURL=StockBox.js.map